import './LazyMarketingCredit.css'

/**
 * The Lazy Marketing signature, shared by the storefront footer and the admin
 * sidebar so the two can never drift.
 *
 * "Crafted with intention by" stays in the surrounding text's own face and
 * size — it is a sentence, not a logo. The agency itself is their own lockup:
 * the square "lm" tile on the left, the wordmark beside it, and an outbound
 * arrow so it reads as a link rather than decoration.
 *
 * Both images are self-hosted copies of the agency's assets (public/logos),
 * trimmed and downsized, so the footer never waits on a third-party host.
 *
 * Everything is sized in em, so it tracks whatever line it is dropped into;
 * `scale` nudges the lockup when a context needs it bigger or smaller.
 * `stacked` puts the lockup on its own line under the sentence, for narrow
 * places like the 240px admin sidebar.
 */
export default function LazyMarketingCredit({
  prefix = 'Crafted with intention by',
  scale = 1,
  stacked = false,
  className = '',
}) {
  return (
    <span
      className={`lmcredit${stacked ? ' lmcredit--stacked' : ''} ${className}`.trim()}
      style={{ '--lmcredit-scale': scale }}
    >
      <span className="lmcredit__prefix">{prefix}</span>
      <a
        className="lmcredit__link"
        href="https://lazymarketing.agency/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Lazy Marketing Agency — opens in a new tab"
      >
        <img
          className="lmcredit__icon"
          src="/logos/lazy-marketing-icon.webp"
          alt=""
          width="96"
          height="96"
          loading="lazy"
          decoding="async"
        />
        <img
          className="lmcredit__wordmark"
          src="/logos/lazy-marketing-wordmark.webp"
          alt=""
          width="443"
          height="88"
          loading="lazy"
          decoding="async"
        />
        <span className="lmcredit__arrow" aria-hidden="true">↗</span>
      </a>
    </span>
  )
}
